"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
var _SvgIcon = require("../icons/SvgIcon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var SlidePanel = /*#__PURE__*/function (_React$Component) {
  _inherits(SlidePanel, _React$Component);
  var _super = _createSuper(SlidePanel);
  function SlidePanel(props) {
    var _this;
    _classCallCheck(this, SlidePanel);
    _this = _super.call(this, props);
    _this.panelContentContainerRef = /*#__PURE__*/_react["default"].createRef();
    _this.panelCloseButtonRef = /*#__PURE__*/_react["default"].createRef();
    // so we can restore keyboard focus to the DOM element that had keyboard focus prior to opening the slide panel
    _this.activeElementPriorToPanelOpen = null;
    return _this;
  }
  _createClass(SlidePanel, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.open === false && nextProps.open === false ? false : true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.open === true && prevProps.open === false) {
        this.activeElementPriorToPanelOpen = this.getWindow().document.activeElement;
        this.panelCloseButtonRef.current.focus(); // eslint-disable-line react/prop-types
      } else if (this.props.open === false && prevProps.open === true) {
        this.activeElementPriorToPanelOpen.focus(); // eslint-disable-line react/prop-types
      }
    }
  }, {
    key: "getWindow",
    value: function getWindow() {
      return window;
    }
  }, {
    key: "getPanelClassName",
    value: function getPanelClassName(open, left, className) {
      var positionClass = open ? 'on-screen' : 'off-screen';
      var defaultClassName = 'slide-panel';
      return [defaultClassName, left ? 'left' : 'right', positionClass, className || ''].join(' ');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        open = _this$props.open,
        onClickCloseButton = _this$props.onClickCloseButton,
        left = _this$props.left,
        width = _this$props.width,
        className = _this$props.className,
        style = _this$props.style,
        heading = _this$props.heading,
        children = _this$props.children,
        modal = _this$props.modal;
      var panelCssClass = this.getPanelClassName(open, left, className);
      var inlineStyle = style || {};
      if (width) {
        inlineStyle.width = width;
      }
      if (this.panelContentContainerRef && this.panelContentContainerRef.current) {
        if (open) {
          this.panelContentContainerRef.current.style.display = 'block';
        } else {
          // hides panel content after slide off screen animation (ensures keyboard focus cannot enter the offscreen panel content)
          this.getWindow().setTimeout(function () {
            return _this2.panelContentContainerRef.current.style.display = 'none';
          }, 300);
        }
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, modal && open && /*#__PURE__*/_react["default"].createElement("div", {
        className: "slide-panel-modal-background"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: panelCssClass,
        style: inlineStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "panel-container",
        ref: this.panelContentContainerRef
      }, /*#__PURE__*/_react["default"].createElement("header", {
        className: "header"
      }, /*#__PURE__*/_react["default"].createElement("h2", {
        className: "heading"
      }, heading), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        className: "close-btn svg-button no-border",
        ref: this.panelCloseButtonRef,
        onClick: onClickCloseButton,
        disabled: !this.props.open,
        title: "close"
      }, /*#__PURE__*/_react["default"].createElement(_SvgIcon.SvgClose, null))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "content-scroll-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "slide-panel-content"
      }, children)))));
    }
  }]);
  return SlidePanel;
}(_react["default"].Component);
SlidePanel.propTypes = {
  open: _propTypes["default"].bool.isRequired,
  onClickCloseButton: _propTypes["default"].func.isRequired,
  heading: _propTypes["default"].string,
  left: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  width: _propTypes["default"].string,
  style: _propTypes["default"].object,
  modal: _propTypes["default"].bool,
  children: _propTypes["default"].node
};
var _default = SlidePanel;
exports["default"] = _default;